<template>
    <div>
        <!-- Папа -->
        <NavigatorItem
            v-if="currentItem"
            :id="`navigator-item-${currentItem.id}`"
            :key="currentItem.id"
            :to="currentItem.href"
            :line-primary="currentItem.displayName || 'Без названия'"
            :has-parent="true"
            :active="currentItem.currentPage"
            @parent-button-click="$emit('set-level', currentItem.parentId, 'out')"
            :disabled="currentItem.disabled"
            class="navigator-item--header"
            @click.prevent="$emit('set-level', currentItem.parentId, 'out')"
        >
            <span
                v-if="currentItem.badge"
                class="badge"
                slot="badge"
                :class="currentItem.badge.class"
                v-html="currentItem.badge.value"
            ></span>
        </NavigatorItem>

        <!-- Детишки -->
        <NavigatorItem
            v-for="item in currentItemChildren || rootItems"
            :id="`navigator-item-${item.id}`"
            :key="item.id"
            :has-children="item.children && item.children.length != 0"
            :active="item.currentPage"
            :line-primary="item.displayName || 'Без названия'"
            :semi-active="pathToActiveItem.includes(item.id)"
            :to="item.href"
            :attrs="item.attrs"
            :disabled="item.disabled"
            @children-button-click="$emit('set-level', item.id, 'in')"
            @click="
                (e) => {
                    if (item.currentPage) {
                        e.preventDefault();
                        if (item.children && item.children.length != 0) {
                            $emit('set-level', item.id, 'in');
                        }
                    }
                }
            "
        >
            <span
                v-if="item.badge"
                class="badge"
                slot="badge"
                :class="item.badge.class"
                v-html="item.badge.value"
            ></span>
        </NavigatorItem>
    </div>
</template>

<script>
// всё это живет здесь для того, чтобы построение меню из потенциально большого количества элементов
// не влияло на производительность в родительском компоненте

import NavigatorItem from '@/components/Navigator/NavigatorItem.vue';

export default {
    name: 'SlideMenuChildren',

    props: {
        items: {
            type: Array,
            default: () => [],
        },
        currentLevelId: {
            type: [String, Number],
        },
    },

    components: { NavigatorItem },

    computed: {
        itemsMap() {
            return this.items.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {});
        },
        currentItem() {
            if (!this.currentLevelId) {
                return;
            }

            return this.itemsMap[this.currentLevelId];
        },
        currentItemChildren() {
            if (!this.currentLevelId) {
                return;
            }

            if (!this.currentItem?.children?.length) {
                return [];
            }

            const children = this.currentItem.children.map(
                (childId) => this.itemsMap[childId]
            );

            return children;
        },
        pathToActiveItem() {
            const active = this.items.find((item) => item.currentPage);

            const result = [];

            const getPath = (item) => {
                if (!item) return;

                const parent = this.itemsMap[item.parentId];

                if (!parent) return;

                result.push(parent.id);

                if (parent.parentId) {
                    getPath(parent);
                }
            };

            getPath(active);

            return result;
        },
        rootItems() {
            return this.items.filter((item) => item.parentId == null);
        },
    },
};
</script>

<style></style>
